import http from "api";

import { BookstoresLanding } from "modules/Bookstores";

export const getStaticProps = async () => {
    const storesByStates = await http.getBookstoresCountByStates();

    const bookstoresCountByStates = storesByStates.reduce((acc, element) => {
        const { id: countryId, name: countryName } = element.state.country || {};
        const bookstoresCount = element.count;
        const stateName = element.state.name;
        const [firstChar] = stateName;

        if (!acc[countryId]) {
            acc[countryId] = { countryName };
        }

        Object.prototype.hasOwnProperty.call(acc[countryId], firstChar)
            ? (acc[countryId][firstChar] = [
                  ...acc[countryId][firstChar],
                  { stateName, bookstoresCount }
              ])
            : (acc[countryId][firstChar] = [{ stateName, bookstoresCount }]);

        return acc;
    }, {});

    return { props: { bookstoresCountByStates } };
};

export default BookstoresLanding;
